// extracted by mini-css-extract-plugin
export var container = "_gy-0";
export var content = "_gy-3";
export var customerTitle = "_gy-4";
export var empty = "_gy-5";
export var gray = "_gy-6";
export var header = "_gy-7";
export var info = "_gy-8";
export var loading = "_gy-2";
export var loadingCard = "_gy-9";
export var oneLine = "_gy-a";
export var personName = "_gy-e";
export var pillContainer = "_gy-b";
export var selected = "_gy-1";
export var text = "_gy-c";
export var twoLines = "_gy-d";
export var unread = "_gy-f";
export var unreadIndicator = "_gy-g";